import { WhyFundrisePageData, WhyFundrisePageResponse } from 'types/sanity/why-fundrise';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';
import { WhyFundrisePageQuery } from './queries/why-fundrise-page';

export async function getWhyFundriseSanityPage(): Promise<WhyFundrisePageData | null> {
	const { data } = await useQuery<WhyFundrisePageResponse>({
		client: villusClient,
		query: WhyFundrisePageQuery,
		tags: ['why_fundrise_page']
	}).execute();

	return data?.allWhyFundrisePage[0] ?? null;
}
